<template>
  <!-- 发布帖子 -->

  <el-dialog :title="$t('上传宣传账号')" top="0" width="730px" :visible.sync="isVisible" @close="closeModal">

    <div class="prompt">
      {{ $t('宣传账号指您在运营的其他平台账号，比如微博、微信公众号等，可上传账号二维码，其他浏览您主页的用户即可看见') }}
    </div>

    <!-- 表单 -->
    <!-- {{ data }} -->
    <!-- <el-form :model="ruleForm" :rules="rules" :inline="true" ref="ruleForm" class="mt-16">
      <div v-for="(item, index) in ruleForm.content" :key="index" class="ruleForm-list df fww" style="width: 100%;">
        <el-form-item :label="$t('账号类型')" :prop="'tesra_type.' + index + '.value'" class="mr-18">
          <el-select v-model="item.tesra_type" :placeholder="$t('账号类型')">
            <el-option v-for="(option, optionIndex) in data.promotion_type" :key="optionIndex" :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('账号名称')" :prop="'tesra_name.' + index + '.value'">
          <el-input v-model="item.tesra_name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('账号二维码')" :prop="'tesra_qr_code.' + index + '.value'" style="width: 100%;">
          <Uploadimg v-model="item.tesra_qr_code" upType="IMGARR" :isUseOss="true" />
        </el-form-item>
      </div>
    </el-form> -->
    <el-form :model="ruleForm" :rules="rules" :inline="true" ref="ruleForm" class="mt-16">
      <div v-for="(item, index) in ruleForm.content" :key="index" class="ruleForm-list df fww" style="width: 100%;">

        <el-form-item :label="$t('账号类型')" :prop="'content.' + index + '.tesra_type'"
          :rules="[{ required: true, message: $t('请选择账号类型'), trigger: 'change' }]" class="mr-18">
          <el-select v-model="item.tesra_type" :placeholder="$t('账号类型')">
            <el-option v-for="(option, optionIndex) in data.promotion_type" :key="optionIndex" :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('账号名称')" :prop="'content.' + index + '.tesra_name'"
          :rules="[{ required: true, message: $t('请输入账号名称'), trigger: 'blur' }]">
          <el-input v-model="item.tesra_name" :placeholder="$t('请输入')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('账号二维码')" :prop="'content.' + index + '.tesra_qr_code'"
          :rules="[{ required: true, message: $t('请上传二维码'), trigger: 'change' }]" style="width: 100%;">
          <Uploadimg v-model="item.tesra_qr_code" :fileLimit="1" upType="IMGARR" :isUseOss="true" />
        </el-form-item>
      </div>
    </el-form>


    <span slot="footer" class="dialog-footer">
      <el-button @click="clear()" class="btn1">{{ $t('清空') }}</el-button>
      <el-button type="primary" class="btn2" @click="submitPost">{{ $t('确定') }}</el-button>
    </span>
    <div>
      <el-button class="add-btn" @click="handleAdd">+ {{ $t('新增宣传账号') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Uploadimg from "@/components/Uploadimg/index";
import Editor from "../components/Editor/index.vue";
import { clearPromotion } from "@api/expert";

export default {
  components: {
    Editor, Uploadimg
  },
  props: {
    data: {
      type: Object, // 指定参数类型
      required: true, // 是否为必需参数
    },
    promotion_detail: {

    }
  },
  watch: {
    promotion_detail(n, o) {
      if (n && n.length > 0) {
        this.ruleForm = { content: n };
      }
    },
  },
  data() {
    return {
      isVisible: false,
      ruleForm: {
        "content": [
          {
            tesra_type: "",
            tesra_name: "",
            tesra_qr_code: ""
          }
        ]
      },

      rules: {
        'content.*.tesra_type': [
          { required: true, message: this.$t('请选择账号类型'), trigger: 'change' },
        ],
        'content.*.tesra_name': [
          { required: true, message: this.$t('请输入账号名称'), trigger: 'blur' },
        ],
        'content.*.tesra_qr_code': [
          { required: true, message: this.$t('请上传二维码'), trigger: 'change' },
        ]
      },
    };

  },


  methods: {
    // 添加
    handleAdd() {
      this.ruleForm.content.push(
        {
          tesra_type: "",
          tesra_name: "",
          tesra_qr_code: ""
        }
      )
    },
    openModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
      this.$refs['ruleForm'].clearValidate();
      this.$refs['ruleForm'].resetFields();
      setTimeout(() => {
        this.ruleForm = {
          "content": [
            {
              tesra_type: "",
              tesra_name: "",
              tesra_qr_code: ""
            }
          ]
        };
      }, 200);

    },
    async clear() {
      let res = await clearPromotion({ user_id: this.userId });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.isVisible = false;
        this.$emit('clearPromotion');
      }
    },
    submitPost() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('poster-submitted', this.ruleForm);
          setTimeout(() => {
            this.closeModal();
          }, 20);
        } else {
          return false;
        }
      });


    }
  }
};
</script>

<style scoped lang="scss">
.prompt {
  border: 1px solid rgb(238, 243, 254);
  border-radius: 4px;
  /* 场景/Background color/color-bg-1 */
  background: rgb(243, 243, 243);

  color: rgb(25, 25, 25);
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;

}

.ruleForm-list {
  border-bottom: 1px solid rgb(201, 201, 201);
  padding-bottom: 6px;

  &:last-child {
    border-bottom: none
  }

  &:nth-child(n+2) {
    padding-top: 20px;
  }
}

.add-btn {
  min-width: 116px;
  height: 32px;
  border: 1px solid rgb(174, 174, 174);
  border-radius: 4px;
  background: rgb(255, 255, 255);
  padding: 0 16px;
  font-size: 14px;
  color: rgb(25, 25, 25);
  font-family: "harmonyos";
}

::v-deep() {
  .el-form--inline .el-form-item__label {
    color: rgb(89, 89, 89);
    font-family: "harmonyos";
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 4px;
  }

  .el-form-item__content {
    line-height: 28px;
  }

  .el-form--inline {
    display: flex;
    flex-wrap: wrap;

    .el-form-item__content {
      line-height: 28px;
    }

    .el-input__inner {
      height: 28px;
      padding: 3px 12px 3px 12px;
      font-size: 12px;
      border: 1px solid rgb(201, 201, 201);
    }
  }


  .el-form--inline .el-form-item {
    width: calc(50% - 9px);
    margin-right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 14px;

    // &:nth-child(2n) {
    //     margin-left: 18px;
    // }

    .el-select {
      width: 100%;
      line-height: 28px;
    }

    .el-input__icon {
      line-height: 28px;
    }
  }

  .el-form--inline .el-form-item__content {
    width: 100%;
  }

  .el-dialog__header {
    padding: 28px 32px 0px;
  }

  .el-dialog {
    max-height: 82vh;
    border-radius: 12px;
    transform: translateY(-50%);
    top: 50%;
  }

  .el-dialog__body {
    margin-top: 20px;
    width: calc(100% - 20px);
    padding: 0px 12px 2px 32px;
    max-height: calc(82vh - 180px);
    overflow: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
      height: 4px;
      background: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #CF4325;
      border-radius: 8px;
    }
  }

  .el-dialog__footer {
    padding: 26px 36px 26px;
  }

  .dialog-footer {

    .btn1,
    .btn2 {
      min-width: 76px;
      height: 36px;
      border-radius: 30px;
      padding: 0 16px;
      font-size: 14px;
    }

    .btn1 {
      background-color: #ffffff;
      border: 1px solid #ededed;

      &:hover {
        border: 1px solid #d9462f;
      }
    }

    .btn2 {
      background: linear-gradient(to right, #eb6f54, #d9462f);
      border: none;

      &:hover {
        background: linear-gradient(to right, #d9462f, #d9462f);
      }
    }
  }

}
</style>